import React from "react"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import Typography from "../../../node_modules/@material-ui/core/Typography/Typography"
import PropTypes from "prop-types"
import withStyles from "../../../node_modules/@material-ui/core/styles/withStyles"
import landingPageStyle from "../../assets/jss/material-kit-react/views/landingPage"

class FaqScrollDialog extends React.Component {
    state = {
        open: this.props.open,
        scroll: "paper",
    }

    // eslint-disable-next-line
    componentWillReceiveProps(nextProps) {
        this.setState({
            open: nextProps.open,
        })
    }

    render() {
        return (
            <div className="container">
                <Dialog
                    open={this.state.open}
                    onClose={this.props.handleClose}
                    scroll={this.state.scroll}
                    aria-labelledby="scroll-dialog-title">
                    <DialogTitle id="scroll-dialog-title">Frequently Asked Questions</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Typography
                                style={{
                                    fontFamily: "Open Sans, Helvetica, Arial, sans-serif",
                                }}>
                                <p>Coming soon...</p>
                            </Typography>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            type="submit"
                            onClick={this.props.handleClose}
                            color="primary"
                            style={{
                                backgroundColor: "#FFC915",
                                color: "#000",
                            }}>
                            I UNDERSTAND
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

FaqScrollDialog.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
}

export default withStyles(landingPageStyle)(FaqScrollDialog)



// WEBPACK FOOTER //
// ./src/components/ScrollDialog/FaqScrollDialog.jsx